export default {"src":"/_next/static/media/ush-coin.7d18e7d9.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};